import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  text: {
    // fontSize: '1.1rem',
  },
});
